import '../sass/faqs.scss';

(() => {
    const $blocks = document.querySelectorAll('.faqs');

    if (!$blocks) return;

    $blocks.forEach($block => {
        const $faqs = $block.querySelectorAll('.faqs__faq');

        const initFAQs = () => {
            if (!$faqs) return;

            $faqs.forEach($faq => {
                new Details($faq);
            });
        };

        initFAQs();
    });
})();
